import React from "react";
import translate from "../../../../i18n/translate";
import { useNavigate } from 'react-router-dom';
import { IconButton, Button } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import "./CultureCenterIntercept.scss";

const CultureCenterIntercept = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/culturecenter");
    localStorage.setItem("cultureCenterSelected", "true");
  }

  const handleSkipClick = () => {
    navigate("/");
    localStorage.setItem("cultureCenterSelected", "true");
  }

  return (
    <div className="intercept-container">
      <div className="intercept-profile-container">
        <div className="intercept-profile-form-container">
          <div className="intercept-close-button">
            <IconButton aria-label="delete" color="primary" onClick={handleSkipClick} >
              <CloseIcon className="close-icon"></CloseIcon>
            </IconButton>
          </div>
          <div className="intercept-layout">
            <h3 className="intercept-title">{translate("culturecenter_intercept_title")}</h3>
            <div className="intercept-form-row">
              <img src={window.location.origin + "/images/" + "Feature_Illustrations/Culture-notes.svg"} height={"220"} width={"170"} alt="flag" ></img>
              <div className="intercept-body">
                <p>{translate("culturecenter_intercept_text1")}</p>
                <p>{translate("culturecenter_intercept_text2")}</p>
                <div className="intercept-action">
                  <Button
                    onClick={handleButtonClick}
                    disabled={false}
                    className="intercept-button"
                    variant="contained"
                    size="large"
                    color="primary"
                  >
                    {translate("culturecenter_intercept_direct")}
                  </Button>
                  <a className="renewal-link" onClick={handleSkipClick}>{translate("myschedule_rechedule_skipButton")}</a>          
                </div>
              </div>           
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CultureCenterIntercept;
